import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, NgForm, NgModel, Validators } from '@angular/forms';
import { isNullOrUndefined } from 'util';
import { Product, Products } from '../../product/models/product';
import { markAsTouchDeep } from '../../shared/models/form-utilities';

@Component({
  selector: 'app-create-order-product',
  templateUrl: './create-order-product.component.html',
  styleUrls: ['./create-order-product.component.css']
})
export class CreateOrderProductComponent {

  @Input() product: Product;
  @Input() removable: boolean = false;
  @Input() allowRemoval: boolean = false;

  @Output() totalAmountChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() productRemoved: EventEmitter<Product> = new EventEmitter<Product>();

  orderAmount: number = 0;
  totalAmount: number = 0;
  taxAmount: number = 0;
  quantitymulti: number = 1;

  get invalid(): boolean {
    return this.form.touched && !this.form.valid;
  }

  form: FormGroup;

  fields: any = [
    {
      'field': 'component_name',
      'title': 'Component Name',
      'width': '30%',
      'code': true,
      'sort': false,
    },
    {
      'field': 'quantity',
      'title': 'Quantity',
      'width': '25%',
      'code': false,
      'sort': false,
    }
  ];

  constructor() {
    this.form = new FormBuilder().group({
      description: ['', [Validators.required]],
      amount: ['', [Validators.required, Validators.min(1)]],
      quantity: ['', [Validators.required, Validators.min(1)]],
      quantitymulti: ['', [Validators.required, Validators.min(1)]],
    })
  }

  public markFormAsTouched(): boolean {
    markAsTouchDeep(this.form);

    return this.form.valid;
  }

  updateProductData() {
    this.orderAmount = 0;
    this.totalAmount = 0;
    this.taxAmount = 0;
    // element.description = this.descrition[index];

    this.orderAmount += this.product.amount * this.product.quantity;


    this.totalAmount = this.orderAmount + this.taxAmount;
    this.totalAmountChanged.emit(this.totalAmount);
  }

  public updateQuantity(element: any): void {
    this.updateProductData();

    element.components_list.forEach(component => {
      component.qty = element.quantity 
    });
  }

  public updateQuantityamount(element: any): void {

    let tempamount = this.quantitymulti;

    console.log(tempamount);
    element.components_list.forEach(component => {
      component.qty = element.quantity * tempamount;
      // component['highlighted'] = true;
    });
    element.quantity =element.quantity * tempamount;
    this.updateProductData();
  }

  

  getFirstError(control: AbstractControl): string {
    if (isNullOrUndefined(control) || isNullOrUndefined(control.errors)) {
      return null;
    }
    const key = Object.keys(control.errors)[0];
    return control.errors[key];
  }

  removeProduct(event: Event): void {

    this.productRemoved.emit(this.product);
    this.updateProductData();

    event.stopPropagation();
  }
}
